import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "../App";
import { Calendar, Clock, MapPin } from "lucide-react";

export default function Appointments() {
  const [appts, setAppts] = useState([]);
  const load = () => axios.get(`${API}/appointments`).then(r => setAppts(r.data));
  useEffect(() => { load(); }, []);


  const cancel = async (id) => {
    await axios.post(`${API}/appointments/${id}/cancel`);
    load();
  };

  const upcoming = appts.filter(a => a.status === "upcoming");
  const past = appts.filter(a => a.status !== "upcoming");

  return (
    <div className="space-y-6" data-testid="appointments-page">
      <h1 className="font-heading text-3xl font-extrabold">Appointments</h1>

      <Section title="Upcoming">
        {upcoming.length === 0 && <Empty text="No upcoming visits. Book a vet from the Vets tab." />}
        <div className="grid md:grid-cols-2 gap-4">
          {upcoming.map(a => <ApptCard key={a.appointment_id} a={a} onCancel={() => cancel(a.appointment_id)} />)}
        </div>
      </Section>

      <Section title="Past & Cancelled">
        {past.length === 0 && <Empty text="Nothing here yet." />}
        <div className="grid md:grid-cols-2 gap-4">
          {past.map(a => <ApptCard key={a.appointment_id} a={a} />)}
        </div>
      </Section>
    </div>
  );
}

const Section = ({ title, children }) => (
  <section>
    <h2 className="font-heading text-xl font-bold mb-3">{title}</h2>
    {children}
  </section>
);

const Empty = ({ text }) => (
  <div className="bg-surface-muted border border-dashed border-line rounded-3xl p-6 text-sm text-ink-soft">{text}</div>
);

const ApptCard = ({ a, onCancel }) => (
  <div data-testid={`appt-${a.appointment_id}`} className="bg-surface border border-line rounded-3xl p-5 shadow-soft">
    <div className="flex items-center justify-between">
      <div className="font-heading text-lg font-bold">{a.service} · {a.pet_name}</div>
      <span className={`text-xs font-bold uppercase tracking-wider px-2 py-1 rounded-full ${a.status === "upcoming" ? "bg-leaf/30 text-ink" : "bg-surface-muted text-ink-soft"}`}>{a.status}</span>
    </div>
    <div className="mt-2 text-sm text-ink-soft space-y-1">
      <div className="flex items-center gap-1.5"><Calendar className="w-3.5 h-3.5"/> {new Date(a.date_time).toLocaleString()}</div>
      <div className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5"/> {a.vet_name} · {a.clinic}</div>
    </div>
    {onCancel && (
      <button data-testid={`cancel-${a.appointment_id}`} onClick={onCancel} className="mt-4 text-sm font-bold text-danger hover:underline">Cancel</button>
    )}
  </div>
);
